import * as React from 'react'
import { useService } from '../../../hooks/use-service'
import { JourneyService } from '../../../services'
import { useAxiosCancelToken } from '../../../hooks/use-axios-cancel-token'
import { useDebouncer } from '@pushly/aqe/lib/hooks'

import { IScheduleData, OccurrenceDTO } from '../types'

export interface IUseNextOccurrencesCoreInput {
  data: IScheduleData
}

export interface IUseNextOccurrencesCoreOutput {
  occurrences: OccurrenceDTO[]
  loading: boolean
  currTz: string
}

export function useNextOccurrencesCore({ data }: IUseNextOccurrencesCoreInput): IUseNextOccurrencesCoreOutput {
  const svc = useService<JourneyService>(JourneyService)
  const [cancelToken, refreshCancelToken] = useAxiosCancelToken()
  const [debounce] = useDebouncer()

  const [occurrences, setOccurrences] = React.useState<OccurrenceDTO[]>([])
  const [loading, setLoading] = React.useState<boolean>(true)

  const currTz = data.timeZone || 'UTC'

  React.useEffect(() => {
    setLoading(true)
    refreshCancelToken()

    const dateStart = data.dateStart != null ? String(data.dateStart) : undefined
    const dateEnd = data.dateEnd != null ? String(data.dateEnd) : undefined

    debounce(() =>
      svc
        .fetchNextOccurrencesByQuery(
          {
            dateStart,
            dateEnd,
            configuration: { schedule: data.schedule },
          },
          { cancellationToken: cancelToken.current },
        )
        .then((res) => {
          setOccurrences(res.data ?? [])
          setLoading(!!(res as any)?.cancelled)
        })
        .catch(() => setLoading(false)),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data.schedule)])

  return { occurrences, loading, currTz }
}
